import React from "react";

import { Container, Row, Col } from "reactstrap";

function FeatureHome() {
  return (
    <div className="section features-3 bg-default">
      <Container>
        <Row className="text-center justify-content-center">
          <Col lg="10">
            <h3 className="display-3 text-white">
              Everything we do involves
              <span className="text-info font-weight-bold">Human Intelligence</span>
            </h3>
            <p className="lead text-white font-weight-normal">
            Many intelligence providers primarily rely on open-source 
            and black-box tools for their intelligence gathering and analysis. 
            These tools, often powered by advanced algorithms and machine 
            learning models, can process vast amounts of data quickly and 
            efficiently. However, they lack the nuanced understanding and 
            contextual insight that human analysis provides. As a result, 
            these providers may miss critical subtleties and fail to interpret 
            complex scenarios accurately. By depending solely on automated 
            systems, they risk overlooking important details that only human 
            expertise can uncover, potentially compromising the quality and 
            reliability of their intelligence outputs.
            </p>
          </Col>
        </Row>
        <Row className="row-grid mt-5">
          <Col lg="6">
            <div className="info info-horizontal bg-default">
              <div className="icon icon-shape icon-shape-info rounded-circle text-info">
                <i className="ni ni-hat-3 text-white"></i>
              </div>
              <div className="description pl-4">
                <h5 className="title text-info">When Only Using OSINT Tools</h5>
                <p className=" font-weight-normal text-white">
                  Open-source intelligence &#40;OSINT&#41; tools can lead to information 
                  overload due to the vast amount of publicly available data, making it 
                  hard to filter actionable insights. They are limited to publicly accessible 
                  information, which can result in an incomplete picture. The accuracy and 
                  reliability of OSINT data can be questionable, as it may include outdated, 
                  biased, or misleading information. Additionally, OSINT tools often lack the 
                  contextual understanding that human analysis provides, potentially leading 
                  to misinterpretations.
                </p>
              </div>
            </div>
          </Col>
          <Col lg="6">
            <div className="info info-horizontal bg-default">
              <div className="icon icon-shape icon-shape-info rounded-circle text-info">
                <i className="ni ni-istanbul text-white"></i>
              </div>
              <div className="description pl-4">
                <h5 className="title text-info">Advantages of Using HUMINT</h5>
                <p className=" font-weight-normal text-white">
                Human intelligence &#40;HUMINT&#41; offers nuanced and context-rich information 
                directly from human sources. HUMINT operatives can build relationships, 
                understand motivations, and interpret subtle cues that automated tools might 
                miss. This adaptability allows HUMINT to respond to rapidly changing situations 
                in real-time. By combining human expertise with technological tools, HUMINT can 
                validate and cross-check data, ensuring its accuracy and reliability, thus 
                enhancing the overall quality of intelligence.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FeatureHome;
